import CreateInventoryTypeContent from "../../content/inventoryType/createInventoryType";
import { Layout } from "../../layout/page";

export function CreatedInventoryTypeInput() {
  return (
    <Layout>
      <CreateInventoryTypeContent />
    </Layout>
  );
}
